import type * as React from 'react';

function SvgAccountFull(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path d="M12 14C17.5137 14 22 17.5889 22 22H2C2 17 6.4863 14 12 14Z" fill="currentColor" />
      <path
        d="M12 2C14.7568 2 17 4.2432 17 7C17 9.7568 14.7568 12 12 12C9.2432 12 7 9.7568 7 7C7 4.2432 9.2432 2 12 2Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgAccountFull;
